import Icon from "@ant-design/icons";

const SVG = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M8 9l-4 3 4 3" />
    <path d="M16 9l4 3-4 3" />
    <path d="M14 5l-4 14" />
  </svg>
);

const CodeIcon = (props) => <Icon component={SVG} {...props} />;

export default CodeIcon;
